import React from "react";
import { Link } from "react-router-dom";
import { X, Mail } from "lucide-react";
import Grain from "../components/Grain";

export default function ReservationCancel() {
  return (
    <div className="section-dark min-h-screen pt-32 pb-20 relative">
      <Grain />
      <div className="max-w-xl mx-auto px-6 text-center relative z-10" data-testid="cancel-page">
        <div className="w-14 h-14 rounded-full bg-red-500/15 border border-red-500/40 flex items-center justify-center mx-auto mb-6">
          <X size={24} className="text-red-300" />
        </div>
        <h1 className="font-serif text-4xl mb-3">Paiement annulé</h1>
        <p className="text-text-cream/60 font-light mb-8">
          Pas de souci — ton créneau n'a pas été réservé. Tu peux reprendre à tout moment en relançant la réservation.
        </p>
        <div className="space-x-3">
          <Link to="/reservation" className="btn-primary inline-flex">Reprendre la réservation</Link>
          <a href="mailto:studioeuclides25@gmail.com" className="btn-ghost inline-flex">
            <Mail size={14} className="mr-2" /> Besoin d'aide
          </a>
        </div>
      </div>
    </div>
  );
}
